export default "/images/332e81291c5bbf5d9670a754b3b5b85c.avif";